import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/sys/subscription";

export default {
    /** 分页查询订阅列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 到期预警档计数 */
    queryExpireStats: () => axios.get({url: `${PREFIX_URI}/queryExpireStats`}),
    /** 查询订阅详情（含续费历史） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),
    /** 保存订阅 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除订阅 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
    /** 续费 */
    renew: (data) => axios.post({url: `${PREFIX_URI}/renew`, data: data}),
};
